import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-bill-pay-details',
  templateUrl: './bill-pay-details.component.html',
  styleUrl: './bill-pay-details.component.scss'
})
export class BillPayDetailsComponent {

  @Input() bill:any
  @Input() isTransactionView:boolean = false
  

  infoList:any = []

  constructor(
    public modalService:NgbModal,
  ) {}

  ngOnInit(){
    this.infoList = [
      {
        label: 'Common.CardType',
        data: this.bill.CardOption
      },
      {
        label: 'Common.CardNumber',
        data: this.bill.CardNumber
      },
      // {
      //   label: 'Common.BalanceTotal',
      //   data: this.isTransactionView ? this.bill.TransferedBalance : this.bill.Total
      // },
      {
        label: this.isTransactionView ? 'Common.TotalAmount': 'Common.BalanceTotal',
        data:  this.bill.Total
      },
      {
        label: 'Common.Tax',
        data: this.bill.Vat
      },
      {
        label: 'Common.Commission',
        data: this.bill.BankCommission
      },
      {
        label: 'Common.TransferedAmount',
        data: this.bill.TotalAfterVat
      },
    ] 

    console.log("ddsf",this.infoList);
    
  }
}
